var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"qr-image-wrapper"},[_c('div',{staticClass:"qr-image",style:({ backgroundImage: 'url(' + _vm.imageCode + ')' })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }